import { useEffect, useRef } from 'react';

import { useSearchOverlayStore } from '../_store/searchOverlayStore';

export function usePageSearchBarVisibility() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const target = ref.current;
    if (!target) return;

    const { setPageSearchBarVisible, reset } = useSearchOverlayStore.getState();

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      setPageSearchBarVisible(entry.isIntersecting);
    });

    observer.observe(target);

    return () => {
      observer.disconnect();
      reset();
    };
  }, []);

  return { ref };
}
